import axios from "axios";
import ClearSession from "./ClearSession";

// Use environment variable or fallback to local development
// export const BASEURL = "http://localhost:5000";
// Production URL:
export const BASEURL = "https://api.cmemove.com";
const apiBaseUrl = `${BASEURL}/api/`;
const APIUser = `${apiBaseUrl}vendor/`;
// const APISuperadmin = `${apiBaseUrl}superAdmin/`
// const APIBank = `${apiBaseUrl}bank/`

export const ApiUrl = {
  signup: `${APIUser}signup`,
  accountVerification: `${apiBaseUrl}user/account/verification`,
  login: `${APIUser}login`,
  forgotPassword: `${APIUser}forgot/password`,
  resendEmail: `${APIUser}resend-email`,
  resetPassword: `${APIUser}reset/password`,
  delete_vendor: `${apiBaseUrl}admin/delete/user/`,
  cancelSubscription: `${apiBaseUrl}vendor/delete/user`,
  deleteUser: `${apiBaseUrl}admin/delete/user`,
  profile_updated: `${apiBaseUrl}user/update/profile`,
  get_dasboard_stats: `${APIUser}dashboard/stats`,
  // Image upload api route ===========
  uploadFile: `${apiBaseUrl}moving/service/upload/file`,
  uploadProductCsvJson: `${apiBaseUrl}product/upload/csv`,

  getFailedPayouts: `${apiBaseUrl}admin/get/failed-payouts`,
  retryVendorPayout: `${apiBaseUrl}admin/retry/payout`,
  addHouse: `${apiBaseUrl}moving/service/add/house`,
  addStorage: `${apiBaseUrl}moving/service/add/storage`,
  geMovingServiceById: `${apiBaseUrl}moving/service/by/`, // append ID
  // update profile ==========
  updateProfile: `${apiBaseUrl}user/update/profile`,
  getUserDetails: `${apiBaseUrl}user/get/details`,
  vendorUploadImage: `${apiBaseUrl}vendor/upload/image`,
  uploadVideo: `${apiBaseUrl}moving/service/upload/video`,

  // moving deals =========
  getAllMovingDeals: `${apiBaseUrl}operator/moving/deals`,
  deleteMovingDeal: `${apiBaseUrl}moving/deals/`,
  getAllDealTags: `${apiBaseUrl}moving/deals/tags`,
  getAllActiveMovingDeals: `${apiBaseUrl}moving/deals/active`,
  createDeal: `${apiBaseUrl}moving/deals`,

  // moving jobs =========
  createMovingJob: `${apiBaseUrl}moving/jobs`,
  getAllMovingJobs: `${apiBaseUrl}moving/operator/jobs`,
  deleteMovingJob: `${apiBaseUrl}moving/jobs/`, // append ID
  updateMovingJobStatus: `${apiBaseUrl}moving/jobs/update/status`,
  getAlMovingJobsAdmin: `${apiBaseUrl}moving/jobs/admin/all`,
  getTrendingDealsForAdmin: `${apiBaseUrl}trending/admin/get/all`,
  getMovingJobsForAdmin: `${apiBaseUrl}moving/admin/jobs`,
  getMovingDealsForAdmin: `${apiBaseUrl}admin/moving/deals`,
  deleteJobForAdmin: `${apiBaseUrl}moving/job/admin/delete`,
  deleteTrendingByAdmin: `${apiBaseUrl}trending/admin/delete`,
  deleteMovingDealByAdmin: `${apiBaseUrl}admin/moving/deals/delete`,

  // feedback api route =========
  feedbackAdd: `${apiBaseUrl}feedback/add`,

  // get vendor quotation api route =============
  vendorQuotation: `${apiBaseUrl}quotation/get/by/userId`,

  // transactions
  transaction_get: `${apiBaseUrl}transaction/get/all`,
  transactionDetailsBytId : `${apiBaseUrl}get/transaction-details/`,
  // store getapi==================
  storeGetApi: `${apiBaseUrl}store/get/all`,
  getVendorStore: `${apiBaseUrl}store/vendor/my-stores`,
  updateStoreByVendor: `${apiBaseUrl}store/vendor/update/`,
  storeAdd: `${apiBaseUrl}store/add`,
  storeGetById: `${apiBaseUrl}store/get/`, // append ID
  storeUpdate: `${apiBaseUrl}store/update/`, // append ID
  storeDelete: `${apiBaseUrl}store/delete/`, // append ID
  storeVerify: `${apiBaseUrl}store/verify/`, // append ID
  storesByType: `${apiBaseUrl}store/type/`, // append type

  // vendor store endpoints
  vendorMyStore: `${apiBaseUrl}store/vendor/my-store`, // get vendor's assigned store
  vendorStoreList: `${apiBaseUrl}store/vendor/list`, // get all stores for vendor

  // subscribe api================
  subscribeGetApi: `${apiBaseUrl}vendor/subscribers`,
  get_subscription_status: `${apiBaseUrl}get/subscription/status`,
  create_subscription_yearly_checkout: `${apiBaseUrl}create/subscription/transaction`,
  confirm_subscription_yearly_checkout: `${apiBaseUrl}confirm/subscription/transaction`,
  refundMoving: `${apiBaseUrl}refund`,

  downloadSubscriber: `${apiBaseUrl}subscribe/download/excel`,

  // update status api route =============
  changeStatus: `${apiBaseUrl}quotation/change/status`,
  changeVendorStatus: `${apiBaseUrl}quotation/vendor/change/status`,
  getOrderById: `${apiBaseUrl}vendor/order/get/by/`,
  orderStatusChange: `${apiBaseUrl}vendor/order/change/status`,
  adminStatusChange: `${apiBaseUrl}admin/change/status`,
  adminGetAllLocations: `${apiBaseUrl}admin/get/all/locations`,
  // add service area api route end point
  addServiceArea: `${apiBaseUrl}service/area/add`,
  getServiceDetails: `${apiBaseUrl}service/area/get`,
  deleteServiceArea: `${apiBaseUrl}service/area/delete/`,
  // add store location api route end point
  addStoreLocation: `${apiBaseUrl}store/location/add`,
  getStoreLocationDetails: `${apiBaseUrl}store/location/get`,
  updateStoreLocation: `${apiBaseUrl}store/location/update`,
  deleteStoreLocation: `${apiBaseUrl}store/location/delete/`,
  getAllNotifications: `${apiBaseUrl}notification/get/all`,
  readNotification: `${apiBaseUrl}notification/read`,

  // add service area api route end point
  getAllVendor: `${apiBaseUrl}moving/service/get/all/vendor`,
  getAllCustomers: `${apiBaseUrl}admin/get/all`,
  getAllUserForBulkEmail: `${apiBaseUrl}admin/get/bulk/email/users`,
  sendBulkEmail: `${apiBaseUrl}admin/bulk-email/send`,
  getAllBulkEmails: `${apiBaseUrl}admin/bulk-email`,

  addQuotation: `${apiBaseUrl}quotation/add`,
  totalQuotation: `${apiBaseUrl}quotation/get/by/vendorId`,
  approvedQuotation: `${apiBaseUrl}quotation/approved/get/by/vendorId`,
  approvedQuotationWithAgreement: `${apiBaseUrl}moving/service/get/approved/by/vendorId`,
  editServiceArea: `${apiBaseUrl}service/area/update`,
  getServiceArea: `${apiBaseUrl}service/area/get`,

  // Image upload api route ===========
  uploadiImage: `${apiBaseUrl}moving/service/upload/image`,
  storeUploadImage: `${apiBaseUrl}upload/image`,
  storeUploadVideo: `${apiBaseUrl}upload/video`,
  // product relative api end point route =========
  addProduct: `${apiBaseUrl}product/add`,
  addProductSet: `${apiBaseUrl}new/product-set`,
  getAllProduct: `${apiBaseUrl}product/vendor/get/all`,
  getProductById: `${apiBaseUrl}product/vendor/get/by/`,
  getAllProductSets: `${apiBaseUrl}product-sets/vendor/get/all`,
  getProductSetById: `${apiBaseUrl}vendor/product-set/by/`,

  deleteProduct: `${apiBaseUrl}product/delete/`,
  deleteProductSet: `${apiBaseUrl}delete/product-set/`,
  getAllProductByVendorId: `${apiBaseUrl}product/user/get/all/product/by/vendorId`,
  getVendorProductByCategory: `${apiBaseUrl}product/vendor/get/all/product/by/category`,
  getProductsType: `${apiBaseUrl}product/user/get/product/type`,
  getProductsTags: `${apiBaseUrl}product/user/get/product/tags`,
  productsByStore: `${apiBaseUrl}product/store/`,
  productsByStoreAndVendor: `${apiBaseUrl}product/store/vendor/`, // append storeId for vendor-specific products

  // product relative api end point route =========
  helpQueryAdd: `${apiBaseUrl}help/query/add`,
  helpQueryReply: `${apiBaseUrl}help/query/reply`,
  Get_Help_Query: `${apiBaseUrl}help/query/get/all`,
  getAllFeedbacks: `${apiBaseUrl}feedback/get/all`,
  trendingAdd: `${apiBaseUrl}trending/add`,
  trendinGetAll: `${apiBaseUrl}vendor/hot-deals`,
  trendinDelete: `${apiBaseUrl}trending/delete/`,

  // order transaction table ==============
  getAllOrder: `${apiBaseUrl}vendor/order/get/all`,

  // Job Management API endpoints
  getAllJobs: `${apiBaseUrl}jobs/get/all`,
  getJobById: `${apiBaseUrl}jobs/get/`, // append ID
  updateJob: `${apiBaseUrl}jobs/update/`, // append ID
  updateJobStatus: `${apiBaseUrl}jobs/update/status`,
  getJobItems: `${apiBaseUrl}jobs/items/`, // append job ID
  getJobPhotos: `${apiBaseUrl}jobs/photos/`, // append job ID
  getJobQuotes: `${apiBaseUrl}jobs/quotes/`, // append job ID
  getJobComments: `${apiBaseUrl}jobs/comments/`, // append job ID
  addJobComment: `${apiBaseUrl}jobs/comments/add`,
  getJobHistory: `${apiBaseUrl}jobs/history/`, // append job ID
  assignJobToVendor: `${apiBaseUrl}jobs/assign`,
  jobAnalytics: `${apiBaseUrl}jobs/analytics`,

  // Location Management API endpoints
  getAllLocations: `${apiBaseUrl}locations/get/all`,
  validateLocation: `${apiBaseUrl}locations/validate`,
  getLocationsByVendor: `${apiBaseUrl}locations/vendor/`, // append vendor ID
  updateLocationStatus: `${apiBaseUrl}locations/update/status`,
  getServiceAreaCoverage: `${apiBaseUrl}service-area/coverage`,
  validateServiceArea: `${apiBaseUrl}service-area/validate`,

  // Quote Management API endpoints
  getAllQuotes: `${apiBaseUrl}quotes/get/all`,
  getQuoteById: `${apiBaseUrl}quotes/get/`, // append ID
  generateQuote: `${apiBaseUrl}quotes/generate`,
  updateQuoteStatus: `${apiBaseUrl}quotes/update/status`,
  getQuoteHistory: `${apiBaseUrl}quotes/history/`, // append quote ID
  quotePricingStrategies: `${apiBaseUrl}quotes/pricing/strategies`,
  quoteAnalytics: `${apiBaseUrl}quotes/analytics`,

  // Job Agreement API endpoints
  acceptAgreement: `${apiBaseUrl}jobAgreement/approve/`,
  rejectAgreement: `${apiBaseUrl}jobAgreement/reject`,
  updateAgreement: `${apiBaseUrl}jobAgreement/update`,
  getJobAgreementByQuotationId: `${apiBaseUrl}jobAgreement/quotation/`,

  // Communication Management API endpoints
  getAllMessages: `${apiBaseUrl}messages/get/all`,
  getMessagesByJob: `${apiBaseUrl}messages/job/`, // append job ID
  sendMessage: `${apiBaseUrl}messages/send`,
  markMessageAsRead: `${apiBaseUrl}messages/read`,
  getNotifications: `${apiBaseUrl}notifications/get/all`,
  markNotificationAsRead: `${apiBaseUrl}notifications/read`,

  // Vendor Management API endpoints
  getVendorAnalytics: `${apiBaseUrl}vendor/analytics/`, // append vendor ID
  getVendorPerformance: `${apiBaseUrl}vendor/performance/`, // append vendor ID
  updateVendorStatus: `${apiBaseUrl}vendor/update/status`,
  getVendorJobs: `${apiBaseUrl}vendor/jobs/`, // append vendor ID
  getVendorQuotes: `${apiBaseUrl}vendor/quotes/`, // append vendor ID

  // System Administration API endpoints
  getSystemConfig: `${apiBaseUrl}admin/config`,
  updateSystemConfig: `${apiBaseUrl}admin/config/update`,
  getSystemAnalytics: `${apiBaseUrl}admin/analytics`,
  getUserManagement: `${apiBaseUrl}admin/users/get/all`,
  updateUserStatus: `${apiBaseUrl}admin/users/update/status`,
  getSystemLogs: `${apiBaseUrl}admin/logs`,

  // Stripe Connect API endpoints
  stripeCreateAccount: `${apiBaseUrl}stripe/connect/account`,
  stripeAccountStatus: `${apiBaseUrl}stripe/connect/account/status/`, // append vendor ID
  stripeAccountLink: `${apiBaseUrl}stripe/connect/account-link`,
  stripeLoginLink: `${apiBaseUrl}stripe/connect/login-link`,
  stripeWebhook: `${apiBaseUrl}stripe/webhook`,

  // Insurance Management API endpoints
  getInsuranceInfo: `${apiBaseUrl}vendor/insurance`,
  updateInsuranceInfo: `${apiBaseUrl}vendor/insurance`,
  uploadInsuranceCertificate: `${apiBaseUrl}vendor/insurance/upload`,
  getAllVendorInsurance: `${apiBaseUrl}admin/vendor/insurance/all`,

  // Chat API endpoints
  getChatListWithChat: `${apiBaseUrl}chat/getChatListWithChat`,
  chatConversation: `${apiBaseUrl}chat/conversation`,
  chatFileUpload: `${apiBaseUrl}chat/send/file`,

  // comments
  getVendorRatings: `${apiBaseUrl}rating/get/by/vendorId`,

  // Specific endpoints for different user types
  getAllUsers: `${apiBaseUrl}admin/user/get/all`,
  getAllVendors: `${apiBaseUrl}admin/vendor/get/all`,
  getAllServiceOperators: `${apiBaseUrl}admin/service-operator/get/all`,

  //stripe urls
  stripeConnectOnboard: `${apiBaseUrl}stripe/connect/onboard`,
  stripeConnectStatus: `${apiBaseUrl}stripe/connect/status/`,
  stripeConnectDashboard: `${apiBaseUrl}stripe/connect/dashboard/`,

  // Complaint Api endpoints
  getComplaint: `${apiBaseUrl}complaint`,
  createComplaint: `${apiBaseUrl}complaint/create`,
  getComplaintByJob: `${apiBaseUrl}complaint/job`,
  listComplaints: `${apiBaseUrl}complaints`,
  reopenComplaint: `${apiBaseUrl}complaint`,
  complaintMessage: `${apiBaseUrl}complaint`,
  proposeResolution: `${apiBaseUrl}complaint/propose-resolution`,
  respondResolution: `${apiBaseUrl}complaint`,
  updateComplaintStatus: `${apiBaseUrl}complaint`,
  adminSuggestion: `${apiBaseUrl}complaint`,
  forceResolve: `${apiBaseUrl}complaint`,
  getOrderComplaints: `${apiBaseUrl}complaint/order/`,
};

export const APIRequest = async (
  config = {},
  onSuccess,
  onError,
  noAuth = null
) => {
  const token = JSON.parse(localStorage?.getItem("data"));

  try {
    let data = {};
    if (token && noAuth == null) {
      data = {
        method: config.method,
        url: config.url,
        data: config.body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
    } else {
      data = {
        method: config.method,
        url: config.url,
        data: config.body,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };
    }

    // Add a flag to prevent duplicate API calls
    if (config.preventDuplicate && window.apiCallInProgress) {
      console.warn("Duplicate API call prevented:", config.url);
      return;
    }

    window.apiCallInProgress = true;

    const response = await axios(data);
    window.apiCallInProgress = false;

    if (response.status === 200 || response.status === 201) {
      onSuccess && onSuccess(response.data);
    } else {
      onError && onError(response.data);
    }
  } catch (error) {
    if (
      error?.response?.data?.statusCode === 401 &&
      error?.response?.data?.code === "UNAUTHORIZED"
    ) {
      ClearSession();
    }
    window.apiCallInProgress = false;
    console.error("API Request Error:", error);
    onError && onError(error);
  }
};

export const APIRequestWithFile = async (config = {}, onSuccess, onError) => {
  const token = JSON.parse(localStorage?.getItem("data"));

  try {
    let data;
    if (token) {
      data = {
        method: config.method,
        url: config.url,
        data: config.body,
        headers: {
          Accept: "multipart/form-data",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };
    } else {
      data = {
        method: config.method,
        url: config.url,
        data: config.body,
        headers: {
          Accept: "multipart/form-data",
          "Content-Type": "multipart/form-data",
        },
      };
    }

    axios(data)
      .then((res) => {
        if (+res.status === 200 || +res.status === 201) {
          onSuccess && onSuccess(res.data);
        }
      })
      .catch((err) => {
        onError && onError(err?.response);
      });
  } catch (error) {
    console.error(error);
  }
};
